module.exports = __webpack_public_path__ + "img/girl.fbf0728f.gif";